// Importing these modules from the 'expo' package was deprecated in SDK 33.
// Please import them from the individual unimodule package instead.

export const AR = null;
export const Accelerometer = null;
export const AdMobBanner = null;
export const AdMobInterstitial = null;
export const AdMobRewarded = null;
export const Amplitude = null;
export const Animated = null;
export const AppAuth = null;
export const AppLoading = null;
export const Asset = null;
export const Audio = null;
export const AuthSession = null;
export const BackgroundFetch = null;
export const BarCodeScanner = null;
export const Barometer = null;
export const BlurView = null;
export const Brightness = null;
export const Calendar = null;
export const Camera = null;
export const Constants = null;
export const Contacts = null;
export const Crypto = null;
export const DocumentPicker = null;
export const Easing = null;
export const ErrorRecovery = null;
export const FaceDetector = null;
export const Facebook = null;
export const FacebookAds = null;
export const FileSystem = null;
export const Font = null;
export const GL = null;
export const GLView = null;
export const GestureHandler = null;
export const Google = null;
export const GoogleSignIn = null;
export const Gyroscope = null;
export const Haptic = null;
export const Haptics = null;
export const Icon = null;
export const ImageManipulator = null;
export const ImagePicker = null;
export const IntentLauncher = null;
export const IntentLauncherAndroid = null;
export const KeepAwake = null;
export const LinearGradient = null;
export const LocalAuthentication = null;
export const Localization = null;
export const Location = null;
export const Magnetometer = null;
export const MagnetometerUncalibrated = null;
export const MailComposer = null;
export const MapView = null;
export const MediaLibrary = null;
export const Pedometer = null;
export const Permissions = null;
export const Print = null;
export const PublisherBanner = null;
export const Random = null;
export const SMS = null;
export const SQLite = null;
export const ScreenOrientation = null;
export const SecureStore = null;
export const Segment = null;
export const Sensors = null;
export const Sharing = null;
export const Speech = null;
export const SplashScreen = null;
export const StoreReview = null;
export const Svg = null;
export const TaskManager = null;
export const Transition = null;
export const Transitioning = null;
export const Updates = null;
export const Video = null;
export const WebBrowser = null;
export const WebView = null;
export const takeSnapshotAsync = null;
